import { ColorHex, ExpandDownIcon, TextBase } from '@carboncopyco/ui';
import classNames from 'classnames';
import type React from 'react';
import { useState } from 'react';

interface AdvancedSettingsProps {
  children: React.ReactNode;
  mountWhenHidden?: boolean;
}

export const AdvancedSettings = ({
  children,
  mountWhenHidden,
}: AdvancedSettingsProps) => {
  const [isAdvancedSettingsOpen, setIsAdvancedSettingsOpen] = useState(false);
  return (
    <div className="flex flex-col mt-6">
      <div
        className="flex items-center justify-start ml-2 w-40 cursor-pointer"
        onClick={() => {
          setIsAdvancedSettingsOpen((isOpen) => !isOpen);
        }}
      >
        <TextBase
          color="text-ds-primary-300"
          label="Advanced settings"
        />
        <div className="ml-1">
          <ExpandDownIcon
            rotate={isAdvancedSettingsOpen}
            className="ml-auto flex"
            size={20}
            color={ColorHex.primary300}
          />
        </div>
      </div>
      {(isAdvancedSettingsOpen || mountWhenHidden) && (
        <div
          className={classNames('ml-1', {
            'invisible h-0': mountWhenHidden && !isAdvancedSettingsOpen,
          })}
        >
          {children}
        </div>
      )}
    </div>
  );
};
